"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpTransfer = createHttpTransfer;
const misc_1 = require("@moojo/misc");
const axios_1 = __importStar(require("axios"));
const extractErrorMessage = (data) => {
    let messageFrom = data;
    if (data && typeof data === 'object' && 'error' in data) {
        messageFrom = data.error;
    }
    return (0, misc_1.errorLike)(messageFrom, 'unknown error').message;
};
/**
 * Using Fetch API, since the endpoint might be invoked by the app from service worker.
 * In MV3, service worker has only Fetch API available, without XHR.
 *
 * TODO(roman): if used from Node, a polyfill package should be installed (node-fetch).
 */
function createHttpTransfer(host, port) {
    const client = axios_1.default.create({
        baseURL: `http://${host}:${port}`,
        headers: {
            'Content-Type': 'application/json',
        },
    });
    // TODO(roman): sort out error handling
    return async (payload) => {
        let status = -1;
        let data;
        try {
            const res = await client.post(`/${payload.endpointName}`, payload);
            status = res.status;
            data = res.data;
        }
        catch (e) {
            if ((0, axios_1.isAxiosError)(e)) {
                if (e.code === axios_1.default.AxiosError.ERR_NETWORK) {
                    throw new Error(`Network error, is target HTTP server is up and running?`);
                }
                if (e.response?.data) {
                    throw new Error(extractErrorMessage(e.response.data));
                }
            }
            throw new Error(`unknown error`);
        }
        if (status !== 200) {
            // HTTP 200
            throw new Error(extractErrorMessage(data));
        }
        if (data && typeof data === 'object' && 'error' in data && typeof data.error === 'string') {
            throw new Error(data.error);
        }
        return data;
    };
}
//# sourceMappingURL=data:application/json;base64,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